import Router from 'next/router';

const popstateListener = () => {
  if (typeof window === 'undefined') return;

  const matchRegs = [
    /^\/[a-z]{2}$/,
    /^\/[a-z]{2}\/$/,
    /^\/$/,
  ];

  const handleRouteChange = url => {
    if (matchRegs.some(reg => reg.test(url))) {
      window.location.href = `${window.location.origin}${url}`;
      return false;
    }

    return true;
  };

  Router.events.on('routeChangeStart', handleRouteChange);
};

export default popstateListener;
